(function () {
  function locationOf(shop) {
    return shop.city === shop.country ? shop.country : shop.city + ", " + shop.country;
  }

  function cityKey(shop) {
    return shop.city + "|" + shop.country;
  }

  function project(lat, lng) {
    return {
      x: ((Number(lng) + 180) / 360) * 1000,
      y: ((90 - Number(lat)) / 180) * 500,
    };
  }

  function cityPins(shops) {
    const pins = [];
    const index = {};
    shops.forEach(function (shop) {
      const id = cityKey(shop);
      if (index[id]) {
        index[id].shops.push(shop);
        return;
      }
      const pin = {
        id: id,
        city: shop.city,
        country: shop.country,
        region: shop.region,
        lat: shop.lat,
        lng: shop.lng,
        shops: [shop],
      };
      index[id] = pin;
      pins.push(pin);
    });
    return pins;
  }

  function pinLabel(pin) {
    if (pin.shops.length === 1) {
      return (pin.shops[0].label || pin.shops[0].name) + ", " + locationOf(pin);
    }
    return locationOf(pin) + ", " + pin.shops.length + " stockists";
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function bind(root, shops, paths) {
    const svg = root.querySelector("[data-map]");
    const hits = root.querySelector("[data-hits]");
    const tip = root.querySelector("[data-tip]");
    const directory = root.querySelector("[data-directory]");
    const filters = root.querySelector("[data-filters]");
    const search = root.querySelector("[data-search]");
    const card = root.querySelector("[data-card]");
    const map = root.querySelector(".iutd-stockists__map");
    const scene = root.querySelector("[data-scene]");
    const zoomIn = root.querySelector('[data-zoom="in"]');
    const zoomOut = root.querySelector('[data-zoom="out"]');
    const pins = cityPins(shops);
    let region = "All";
    let query = "";
    let hoverPinId = null;
    let userPicked = false;
    let activeShopId = shops[0] ? shops[0].id : null;
    let zoom = 1;
    let panX = 0;
    let panY = 0;
    let skipClick = false;
    const ZOOM_MIN = 1;
    const MAP_Y = -29;
    const MAP_H = 480;
    const mapBox = { width: 1, height: 1 };
    const dots = {};
    const rings = {};
    const hitDots = {};

    function isMobileMap() {
      return window.matchMedia("(max-width: 800px)").matches;
    }
    function zoomMax() {
      return isMobileMap() ? 16 : 5.6;
    }
    function zoomStep() {
      return isMobileMap() ? 0.55 : 0.28;
    }
    function zoomRate() {
      return isMobileMap() ? 2.8 : 1.35;
    }
    function storeZoom() {
      return isMobileMap() ? 12 : 4.4;
    }

    if (svg && paths && paths.length) {
      paths.forEach(function (d) {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", d);
        path.setAttribute("class", "iutd-stockists__land");
        svg.appendChild(path);
      });
    }

    if (svg) {
      const appearAt = {};
      pins
        .slice()
        .sort(function (a, b) {
          return project(a.lat, a.lng).x - project(b.lat, b.lng).x;
        })
        .forEach(function (pin, index) {
          appearAt[pin.id] = index;
        });
      pins.forEach(function (pin) {
        const dot = project(pin.lat, pin.lng);
        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        group.setAttribute("transform", "translate(" + dot.x + " " + dot.y + ")");
        const pinGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        pinGroup.setAttribute("class", "iutd-stockists__pin");
        pinGroup.style.setProperty("--pin", String(appearAt[pin.id] || 0));
        const hit = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        hit.setAttribute("r", "14");
        hit.setAttribute("class", "iutd-stockists__hitdot");
        const ring = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        ring.setAttribute("r", "9");
        ring.setAttribute("class", "iutd-stockists__ring");
        const ping = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        ping.setAttribute("r", "4.5");
        ping.setAttribute("class", "iutd-stockists__ping");
        const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("r", "4.5");
        circle.setAttribute("class", "iutd-stockists__dot");
        pinGroup.appendChild(hit);
        pinGroup.appendChild(ring);
        pinGroup.appendChild(ping);
        pinGroup.appendChild(circle);
        group.appendChild(pinGroup);
        svg.appendChild(group);
        dots[pin.id] = circle;
        rings[pin.id] = ring;
        hitDots[pin.id] = hit;
        pin._group = pinGroup;

        hit.setAttribute("role", "button");
        hit.setAttribute("tabindex", "0");
        hit.setAttribute("aria-label", pinLabel(pin));
        hit.addEventListener("pointerdown", function (event) {
          event.stopPropagation();
          if (event.pointerType === "mouse" && event.button !== 0) return;
          skipClick = false;
          hoverPinId = pin.id;
          selectPin(pin);
        });
        hit.addEventListener("mouseenter", function () { hoverPinId = pin.id; paint(); });
        hit.addEventListener("mouseleave", function () { if (hoverPinId === pin.id) hoverPinId = null; paint(); });
        hit.addEventListener("focus", function () { hoverPinId = pin.id; paint(); });
        hit.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            hoverPinId = pin.id;
            selectPin(pin);
          }
        });
      });
    }

    if (filters) {
      filters.querySelectorAll("button").forEach(function (button) {
        button.addEventListener("click", function () {
          selectRegion(button.getAttribute("data-region") || "All");
        });
      });
    }

    if (search) {
      search.addEventListener("input", function () {
        query = search.value;
        followSearch();
      });
    }

    if (directory) {
      const tbody = directory.querySelector("tbody");
      if (tbody) {
        tbody.innerHTML = "";
        shops.forEach(function (shop) {
          const row = document.createElement("tr");
          row.setAttribute("data-shop", shop.id);
          row.innerHTML = "<td>" + escapeHtml(shop.name) + "</td><td>" + escapeHtml(locationOf(shop)) + "</td><td>" + escapeHtml(shop.region) + "</td>";
          tbody.appendChild(row);
        });
      }
      directory.querySelectorAll("[data-shop]").forEach(function (row) {
        row.addEventListener("click", function () {
          const shopId = row.getAttribute("data-shop");
          const shop = shops.find(function (entry) { return entry.id === shopId; });
          if (shop) selectShop(shop, true);
        });
      });
    }

    const cardRoot = root.querySelector(".iutd-stockists__card");
    if (cardRoot) {
      cardRoot.addEventListener("click", function (event) {
        const btn = event.target && event.target.closest ? event.target.closest("[data-card-nav]") : null;
        if (!btn) return;
        event.preventDefault();
        stepCityShop(Number(btn.getAttribute("data-card-nav")));
      });
      let cardSwipe = null;
      cardRoot.addEventListener("pointerdown", function (event) {
        if (event.target && event.target.closest && event.target.closest("a, button")) return;
        cardSwipe = { pointerId: event.pointerId, startX: event.clientX };
      });
      cardRoot.addEventListener("pointerup", function (event) {
        if (!cardSwipe || cardSwipe.pointerId !== event.pointerId) return;
        const dx = event.clientX - cardSwipe.startX;
        cardSwipe = null;
        if (Math.abs(dx) < 40) return;
        stepCityShop(dx < 0 ? 1 : -1);
      });
      cardRoot.addEventListener("pointercancel", function () { cardSwipe = null; });
    }

    if (zoomIn) bindZoomHold(zoomIn, 1);
    if (zoomOut) bindZoomHold(zoomOut, -1);

    function measureMap() {
      if (!map) return;
      const box = map.getBoundingClientRect();
      mapBox.width = Math.max(box.width, 1);
      mapBox.height = Math.max(box.height, 1);
    }

    function setZoom(next) {
      const max = zoomMax();
      const clamped = Math.min(max, Math.max(ZOOM_MIN, next));
      if (clamped === zoom) return false;
      zoom = clamped;
      if (zoom <= ZOOM_MIN) {
        panX = 0;
        panY = 0;
      } else {
        clampPanInPlace();
      }
      applyView();
      return zoom > ZOOM_MIN && zoom < max;
    }

    function bumpZoom(direction) {
      measureMap();
      setZoom(zoom + direction * zoomStep());
    }

    let zoomHoldRaf = null;
    let zoomHoldDir = 0;
    let zoomHoldLast = 0;
    let zoomFromPointer = false;
    function stopZoomHold() {
      if (zoomHoldRaf) window.cancelAnimationFrame(zoomHoldRaf);
      zoomHoldRaf = null;
      zoomHoldDir = 0;
      zoomHoldLast = 0;
    }
    function runZoomHold(ts) {
      if (!zoomHoldDir) return;
      if (!zoomHoldLast) {
        zoomHoldLast = ts;
        zoomHoldRaf = window.requestAnimationFrame(runZoomHold);
        return;
      }
      const dt = Math.min(0.05, (ts - zoomHoldLast) / 1000);
      zoomHoldLast = ts;
      if (dt > 0) setZoom(zoom + zoomHoldDir * zoomRate() * dt);
      if (zoom <= ZOOM_MIN || zoom >= zoomMax()) {
        stopZoomHold();
        return;
      }
      zoomHoldRaf = window.requestAnimationFrame(runZoomHold);
    }
    function bindZoomHold(button, direction) {
      var holding = false;
      function startHold(event) {
        if (holding) return;
        holding = true;
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        stopZoomHold();
        zoomFromPointer = true;
        measureMap();
        bumpZoom(direction);
        zoomHoldDir = direction;
        zoomHoldLast = 0;
        zoomHoldRaf = window.requestAnimationFrame(runZoomHold);
      }
      function endHold() {
        if (!holding) return;
        holding = false;
        stopZoomHold();
        window.setTimeout(function () { zoomFromPointer = false; }, 400);
      }
      button.addEventListener("pointerdown", function (event) {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        startHold(event);
        if (button.setPointerCapture) {
          try { button.setPointerCapture(event.pointerId); } catch (err) {}
        }
      });
      button.addEventListener("pointerup", endHold);
      button.addEventListener("touchstart", function (event) {
        startHold(event);
      }, { passive: false });
      button.addEventListener("touchend", function (event) {
        event.preventDefault();
        endHold();
      });
      button.addEventListener("touchcancel", endHold);
      button.addEventListener("click", function (event) {
        event.preventDefault();
        if (zoomFromPointer) return;
        bumpZoom(direction);
      });
      button.addEventListener("contextmenu", function (event) { event.preventDefault(); });
    }

    function clampPanInPlace() {
      const maxX = Math.max(mapBox.width * 0.12, ((zoom - 1) * mapBox.width) / 2);
      const maxY = Math.max(mapBox.height * 0.12, ((zoom - 1) * mapBox.height) / 2);
      panX = Math.min(maxX, Math.max(-maxX, panX));
      panY = Math.min(maxY, Math.max(-maxY, panY));
    }

    function viewForPins(regionPins, width, height) {
      if (!regionPins.length || width < 8 || height < 8) return { zoom: ZOOM_MIN, panX: 0, panY: 0 };
      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;
      regionPins.forEach(function (pin) {
        const point = project(pin.lat, pin.lng);
        const x = (point.x / 1000) * width;
        const y = ((point.y - MAP_Y) / MAP_H) * height;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
      });
      const pad = 64;
      const boxW = Math.max(maxX - minX, 36) + pad * 2;
      const boxH = Math.max(maxY - minY, 36) + pad * 2;
      const nextZoom = Number(Math.min(zoomMax(), Math.max(1.25, Math.min(width / boxW, height / boxH))).toFixed(2));
      return {
        zoom: nextZoom,
        panX: (width / 2 - (minX + maxX) / 2) * nextZoom,
        panY: (height / 2 - (minY + maxY) / 2) * nextZoom,
      };
    }

    function selectRegion(name) {
      region = name;
      hoverPinId = null;
      userPicked = false;
      if (search) {
        search.value = "";
        query = "";
      }
      measureMap();
      if (!map || name === "All") {
        zoom = ZOOM_MIN;
        panX = 0;
        panY = 0;
      } else {
        const view = viewForPins(
          pins.filter(function (pin) { return pin.region === name; }),
          mapBox.width,
          mapBox.height
        );
        zoom = view.zoom;
        panX = view.panX;
        panY = view.panY;
        clampPanInPlace();
      }
      applyView();
      paint();
      replayVisiblePins();
    }

    function replayVisiblePins() {
      const matching = {};
      visibleShops().forEach(function (shop) { matching[cityKey(shop)] = true; });
      const list = pins
        .filter(function (pin) { return matching[pin.id]; })
        .sort(function (a, b) {
          return project(a.lat, a.lng).x - project(b.lat, b.lng).x;
        });
      list.forEach(function (pin, index) {
        if (!pin._group) return;
        pin._group.style.setProperty("--pin", String(index));
        pin._group.style.animation = "none";
      });
      if (svg) svg.getBoundingClientRect();
      list.forEach(function (pin) {
        if (pin._group) pin._group.style.animation = "";
      });
    }

    function pinScreen(pin) {
      if (!map) return null;
      const box = map.getBoundingClientRect();
      const point = project(pin.lat, pin.lng);
      const localX = (point.x / 1000) * box.width;
      const localY = ((point.y - MAP_Y) / MAP_H) * box.height;
      const x = box.width / 2 + (localX - box.width / 2) * zoom + panX;
      const y = box.height / 2 + (localY - box.height / 2) * zoom + panY;
      return { x: x, y: y, below: y < box.height * 0.38 };
    }

    function applyView() {
      if (svg && map) {
        const width = mapBox.width;
        const height = mapBox.height;
        const viewW = 1000 / zoom;
        const viewH = MAP_H / zoom;
        const centerSvgX = ((width / 2 - panX / zoom) / width) * 1000;
        const centerSvgY = ((height / 2 - panY / zoom) / height) * MAP_H + MAP_Y;
        svg.setAttribute(
          "viewBox",
          (centerSvgX - viewW / 2) + " " + (centerSvgY - viewH / 2) + " " + viewW + " " + viewH
        );
      }
      if (scene) scene.style.transform = "";
      if (map) map.style.setProperty("--map-zoom", String(zoom));
      const grow = 0.62 + 0.38 * zoom;
      const target = isMobileMap() ? 24 : 12;
      const hitR = Math.min(40, Math.max(10, target / Math.max((mapBox.width / 1000) * grow, 0.05)));
      Object.keys(hitDots).forEach(function (id) {
        hitDots[id].setAttribute("r", String(hitR));
      });
      if (zoomIn) zoomIn.disabled = zoom >= zoomMax();
      if (zoomOut) zoomOut.disabled = zoom <= ZOOM_MIN;
      positionTip();
    }

    function positionTip() {
      if (!tip || tip.hidden || !hoverPinId) return;
      const focused = pins.find(function (pin) { return pin.id === hoverPinId; });
      if (!focused) return;
      const screen = pinScreen(focused);
      if (!screen) return;
      tip.classList.toggle("is-below", screen.below);
      tip.style.left = screen.x + "px";
      tip.style.top = screen.y + "px";
    }

    const activePointers = {};
    let pinch = null;
    let drag = null;
    function pinchDistance() {
      const ids = Object.keys(activePointers);
      if (ids.length < 2) return 0;
      const a = activePointers[ids[0]];
      const b = activePointers[ids[1]];
      const dx = a.x - b.x;
      const dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function pinchMid() {
      const ids = Object.keys(activePointers);
      const a = activePointers[ids[0]];
      const b = activePointers[ids[1]];
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }
    function zoomAround(nextZoom, screenX, screenY) {
      const cx = mapBox.width / 2;
      const cy = mapBox.height / 2;
      const localX = cx + (screenX - cx - panX) / zoom;
      const localY = cy + (screenY - cy - panY) / zoom;
      const clamped = Math.min(zoomMax(), Math.max(ZOOM_MIN, nextZoom));
      panX += (localX - cx) * (zoom - clamped);
      panY += (localY - cy) * (zoom - clamped);
      zoom = clamped;
      if (zoom <= ZOOM_MIN) {
        panX = 0;
        panY = 0;
      } else {
        clampPanInPlace();
      }
      applyView();
    }

    function beginPinch(ax, ay, bx, by) {
      drag = null;
      skipClick = true;
      hoverPinId = null;
      pinch = {
        dist: Math.hypot(ax - bx, ay - by) || 1,
        zoom: zoom,
        panX: panX,
        panY: panY,
      };
      map.classList.add("is-dragging");
      paint();
    }

    function movePinch(ax, ay, bx, by) {
      if (!pinch) return;
      const dist = Math.hypot(ax - bx, ay - by);
      if (dist < 8) return;
      zoom = pinch.zoom;
      panX = pinch.panX;
      panY = pinch.panY;
      const box = map.getBoundingClientRect();
      zoomAround(
        pinch.zoom * (dist / pinch.dist),
        (ax + bx) / 2 - box.left,
        (ay + by) / 2 - box.top
      );
    }

    function endPinch() {
      if (!pinch) return;
      pinch = null;
      skipClick = true;
      map.classList.remove("is-dragging");
    }

    if (map) {
      map.addEventListener("touchstart", function (event) {
        if (event.target && event.target.closest && event.target.closest(".iutd-stockists__zoom")) return;
        if (event.touches.length >= 2) {
          event.preventDefault();
          beginPinch(
            event.touches[0].clientX,
            event.touches[0].clientY,
            event.touches[1].clientX,
            event.touches[1].clientY
          );
        }
      }, { passive: false });
      map.addEventListener("touchmove", function (event) {
        if (event.touches.length >= 2) {
          event.preventDefault();
          if (!pinch) {
            beginPinch(
              event.touches[0].clientX,
              event.touches[0].clientY,
              event.touches[1].clientX,
              event.touches[1].clientY
            );
          }
          movePinch(
            event.touches[0].clientX,
            event.touches[0].clientY,
            event.touches[1].clientX,
            event.touches[1].clientY
          );
        }
      }, { passive: false });
      map.addEventListener("touchend", function (event) {
        if (event.touches.length < 2) endPinch();
      });
      map.addEventListener("touchcancel", function (event) {
        if (event.touches.length < 2) endPinch();
      });
      map.addEventListener("pointerdown", function (event) {
        const target = event.target && event.target.closest ? event.target : event.target && event.target.parentElement;
        if (target && target.closest && target.closest(".iutd-stockists__zoom")) return;
        if (target && target.closest && target.closest(".iutd-stockists__hitdot, .iutd-stockists__dot") && Object.keys(activePointers).length === 0 && !pinch) {
          return;
        }
        activePointers[event.pointerId] = { x: event.clientX, y: event.clientY };
        if (event.pointerType !== "touch") {
          try { map.setPointerCapture(event.pointerId); } catch (err) {}
        }
        if (Object.keys(activePointers).length >= 2) {
          const ids = Object.keys(activePointers);
          beginPinch(activePointers[ids[0]].x, activePointers[ids[0]].y, activePointers[ids[1]].x, activePointers[ids[1]].y);
          return;
        }
        drag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          originX: panX,
          originY: panY,
          moved: false,
        };
      });
      map.addEventListener("pointermove", function (event) {
        if (activePointers[event.pointerId]) {
          activePointers[event.pointerId].x = event.clientX;
          activePointers[event.pointerId].y = event.clientY;
        }
        if (pinch) {
          if (Object.keys(activePointers).length >= 2) {
            const ids = Object.keys(activePointers);
            movePinch(activePointers[ids[0]].x, activePointers[ids[0]].y, activePointers[ids[1]].x, activePointers[ids[1]].y);
          }
          return;
        }
        if (!drag || drag.pointerId !== event.pointerId) return;
        const dx = event.clientX - drag.startX;
        const dy = event.clientY - drag.startY;
        if (!drag.moved && dx * dx + dy * dy > 64) {
          drag.moved = true;
          map.classList.add("is-dragging");
          hoverPinId = null;
          paint();
        }
        if (!drag.moved) return;
        panX = drag.originX + dx;
        panY = drag.originY + dy;
        clampPanInPlace();
        applyView();
      });
      function endDrag(event) {
        delete activePointers[event.pointerId];
        try {
          if (map.hasPointerCapture(event.pointerId)) map.releasePointerCapture(event.pointerId);
        } catch (err) {}
        if (pinch) {
          drag = null;
          return;
        }
        if (!drag || drag.pointerId !== event.pointerId) return;
        if (drag.moved) skipClick = true;
        drag = null;
        map.classList.remove("is-dragging");
      }
      map.addEventListener("pointerup", endDrag);
      map.addEventListener("pointercancel", endDrag);
      map.addEventListener("wheel", function (event) {
        if (!event.ctrlKey && !event.metaKey) return;
        event.preventDefault();
        measureMap();
        const box = map.getBoundingClientRect();
        const factor = Math.exp(-event.deltaY * 0.012);
        zoomAround(zoom * factor, event.clientX - box.left, event.clientY - box.top);
      }, { passive: false });
      var trackpadGesture = null;
      map.addEventListener("gesturestart", function (event) {
        event.preventDefault();
        measureMap();
        drag = null;
        trackpadGesture = { zoom: zoom, panX: panX, panY: panY };
      });
      map.addEventListener("gesturechange", function (event) {
        event.preventDefault();
        if (!trackpadGesture) {
          trackpadGesture = { zoom: zoom, panX: panX, panY: panY };
        }
        zoom = trackpadGesture.zoom;
        panX = trackpadGesture.panX;
        panY = trackpadGesture.panY;
        const box = map.getBoundingClientRect();
        zoomAround(
          trackpadGesture.zoom * event.scale,
          event.clientX - box.left,
          event.clientY - box.top
        );
      });
      map.addEventListener("gestureend", function (event) {
        event.preventDefault();
        trackpadGesture = null;
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        hoverPinId = null;
        paint();
      }
    });

    function shopMatchesQuery(shop, q) {
      return (shop.name + " " + locationOf(shop) + " " + shop.region).toLowerCase().indexOf(q) !== -1;
    }

    function visibleShops() {
      const q = query.trim().toLowerCase();
      if (q) {
        return shops.filter(function (shop) { return shopMatchesQuery(shop, q); });
      }
      if (region === "All") return shops.slice();
      return shops.filter(function (shop) { return shop.region === region; });
    }

    function followSearch() {
      const q = query.trim();
      if (!q) {
        paint();
        return;
      }
      const matches = visibleShops();
      const regions = [];
      matches.forEach(function (shop) {
        if (regions.indexOf(shop.region) === -1) regions.push(shop.region);
      });
      if (regions.length === 1) region = regions[0];
      else if (matches.length) region = "All";

      if (matches.length === 1) {
        activeShopId = matches[0].id;
        focusShop(matches[0]);
      } else if (matches.length > 1 && map) {
        const ids = {};
        matches.forEach(function (shop) { ids[cityKey(shop)] = true; });
        const matchPins = pins.filter(function (pin) { return ids[pin.id]; });
        measureMap();
        const view = viewForPins(matchPins, mapBox.width, mapBox.height);
        zoom = view.zoom;
        panX = view.panX;
        panY = view.panY;
        clampPanInPlace();
        applyView();
      }
      paint();
      replayVisiblePins();
    }

    function viewForStore(pin, width, height) {
      const nextZoom = storeZoom();
      if (width < 8 || height < 8) return { zoom: nextZoom, panX: 0, panY: 0 };
      const point = project(pin.lat, pin.lng);
      const x = (point.x / 1000) * width;
      const y = ((point.y - MAP_Y) / MAP_H) * height;
      return {
        zoom: nextZoom,
        panX: (width / 2 - x) * nextZoom,
        panY: (height / 2 - y) * nextZoom,
      };
    }

    function focusShop(shop) {
      const pin = pins.find(function (entry) { return entry.id === cityKey(shop); });
      if (!pin || !map) return;
      measureMap();
      const view = viewForStore(pin, mapBox.width, mapBox.height);
      hoverPinId = null;
      zoom = view.zoom;
      panX = view.panX;
      panY = view.panY;
      applyView();
    }

    function selectShop(shop, fromList) {
      activeShopId = shop.id;
      userPicked = true;
      if (fromList) {
        focusShop(shop);
        if (map && window.matchMedia("(max-width: 800px)").matches) {
          map.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
      paint();
    }

    function selectPin(pin) {
      const visible = pin.shops.filter(function (shop) {
        return visibleShops().some(function (item) { return item.id === shop.id; });
      });
      if (!visible.length) return;
      const current = visible.find(function (shop) { return shop.id === activeShopId; });
      selectShop(current || visible[0], false);
    }

    function renderTip(pin) {
      if (pin.shops.length === 1) {
        const shop = pin.shops[0];
        return "<strong>" + escapeHtml(shop.label || shop.name) + "</strong><span>" + escapeHtml(locationOf(pin)) + "</span>";
      }
      let html = "<strong>" + escapeHtml(pin.city) + "</strong><span>" + pin.shops.length + " stockists</span><ul class=\"iutd-stockists__tip-list\">";
      pin.shops.forEach(function (shop) {
        html += "<li><strong>" + escapeHtml(shop.name) + "</strong><span>" + escapeHtml(locationOf(shop)) + "</span></li>";
      });
      return html + "</ul>";
    }

    function cityShopsOf(shop) {
      if (!shop) return [];
      const key = cityKey(shop);
      return visibleShops().filter(function (entry) { return cityKey(entry) === key; });
    }

    function stepCityShop(direction) {
      const filtered = visibleShops();
      const selected = filtered.find(function (entry) { return entry.id === activeShopId; }) || filtered[0];
      const siblings = cityShopsOf(selected);
      if (siblings.length < 2) return;
      const index = siblings.findIndex(function (entry) { return entry.id === selected.id; });
      const next = siblings[(index + direction + siblings.length) % siblings.length];
      selectShop(next, false);
    }

    function renderCard(shop) {
      if (!shop) {
        return "<p>No store selected.</p>";
      }
      const siblings = cityShopsOf(shop);
      const index = siblings.findIndex(function (entry) { return entry.id === shop.id; });
      let html = "<div class=\"iutd-stockists__card-head\"><h3>" + escapeHtml(shop.label || shop.name) + "</h3>";
      if (siblings.length > 1) {
        html += "<div class=\"iutd-stockists__card-nav\">";
        html += "<button type=\"button\" data-card-nav=\"-1\" aria-label=\"Previous store\">‹</button>";
        html += "<button type=\"button\" data-card-nav=\"1\" aria-label=\"Next store\">›</button>";
        html += "</div>";
      }
      html += "</div>";
      html += "<p>" + escapeHtml(locationOf(shop)) + "</p>";
      html += "<em>" + escapeHtml(shop.region) + "</em>";
      if (shop.website) {
        html += '<a class="iutd-stockists__card-link" href="' + escapeHtml(shop.website) + '" target="_blank" rel="noreferrer">Website ↗</a>';
      }
      if (siblings.length > 1) {
        html += "<p class=\"iutd-stockists__card-index\">" + (index + 1) + " of " + siblings.length + " in " + escapeHtml(shop.city) + "</p>";
      }
      return html;
    }

    function paint() {
      const filtered = visibleShops();
      const matching = {};
      filtered.forEach(function (shop) { matching[cityKey(shop)] = true; });
      const selected = filtered.find(function (shop) { return shop.id === activeShopId; }) || filtered[0] || null;
      const selectedPinId = selected ? cityKey(selected) : null;
      if (hoverPinId && !matching[hoverPinId]) hoverPinId = null;
      const focused = pins.find(function (pin) { return pin.id === hoverPinId; });

      pins.forEach(function (pin) {
        const selectedPin = pin.id === selectedPinId;
        const on = pin.id === hoverPinId || selectedPin;
        const dim = !matching[pin.id];
        const muted = userPicked && !dim && !selectedPin && pin.id !== hoverPinId;
        if (pin._group) {
          pin._group.classList.toggle("is-dim", dim);
          pin._group.classList.toggle("is-muted", muted);
        }
        if (dots[pin.id]) {
          dots[pin.id].setAttribute("r", on ? "6" : "4.5");
        }
        if (hitDots[pin.id]) {
          hitDots[pin.id].setAttribute("aria-pressed", String(selectedPin));
          hitDots[pin.id].setAttribute("tabindex", dim ? "-1" : "0");
        }
        if (rings[pin.id]) rings[pin.id].classList.toggle("is-on", selectedPin);
      });

      if (directory) {
        directory.querySelectorAll("[data-shop]").forEach(function (row) {
          const shopId = row.getAttribute("data-shop");
          const shop = shops.find(function (entry) { return entry.id === shopId; });
          const show = shop && filtered.indexOf(shop) !== -1;
          row.hidden = !show;
          row.classList.toggle("is-selected", !!(selected && shopId === selected.id));
        });
      }

      if (filters) {
        filters.querySelectorAll("button").forEach(function (button) {
          const on = button.getAttribute("data-region") === region;
          button.setAttribute("aria-pressed", String(on));
          button.classList.toggle("is-on", on);
        });
      }

      if (card) card.innerHTML = renderCard(selected);

      if (!tip) return;
      if (!focused) {
        tip.hidden = true;
        return;
      }
      const screen = pinScreen(focused);
      tip.hidden = false;
      tip.innerHTML = renderTip(focused);
      if (!screen) return;
      tip.classList.toggle("is-below", screen.below);
      tip.style.left = screen.x + "px";
      tip.style.top = screen.y + "px";
    }

    measureMap();
    if (map && typeof ResizeObserver !== "undefined") {
      new ResizeObserver(function () {
        measureMap();
        applyView();
      }).observe(map);
    }
    paint();
    applyView();
  }

  document.querySelectorAll(".iutd-stockists[data-iutd-map]").forEach(function (root) {
    const blockData = root.querySelector("[data-shops-json]");
    const pathsUrl = root.getAttribute("data-paths");
    const shops = blockData && blockData.textContent.trim()
      ? JSON.parse(blockData.textContent)
      : [];
    const pathsPromise = pathsUrl
      ? fetch(pathsUrl).then(function (res) { return res.json(); })
      : Promise.resolve([]);
    pathsPromise.then(function (paths) {
      bind(root, shops, paths || []);
    });
  });
})();
